window.trackFbq =function(track, type){
    if(typeof window.fbq !== "function"){
        console.log('fbq event', type)
    }else {
        fbq(track, type);
    }
}
